/** @jsxImportSource @emotion/react */
import {
  EuiButtonIcon,
  EuiButtonIconProps,
  EuiPopover,
  EuiPopoverProps,
} from "@inscopix/ideas-eui";
import { Tooltip } from "components/Tooltip/Tooltip";
import { Project } from "graphql/_Types";
import { useState } from "react";
import { ProjectInfoBody } from "../ProjectInfo/ProjectInfoBody";

export interface ButtonProjectInfoProps
  extends Pick<EuiButtonIconProps, "iconSize" | "css" | "color">,
    Pick<EuiPopoverProps, "anchorPosition" | "repositionOnScroll"> {
  projectId: Project["id"];
}

export const ButtonProjectInfo = ({
  projectId,
  anchorPosition,
  repositionOnScroll,
  ...props
}: ButtonProjectInfoProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Tooltip content="View Project Info">
      <EuiPopover
        title=""
        button={
          <EuiButtonIcon
            aria-label="Project info"
            iconType="iInCircle"
            color="primary"
            iconSize="l"
            {...props}
          />
        }
        repositionOnScroll={repositionOnScroll}
        isOpen={isOpen}
        closePopover={() => setIsOpen(false)}
        onClick={() => setIsOpen((isOpen) => !isOpen)}
        anchorPosition={anchorPosition ?? "upLeft"}
      >
        <ProjectInfoBody projectId={projectId} />
      </EuiPopover>
    </Tooltip>
  );
};
